import React, { InputHTMLAttributes, forwardRef, useCallback } from 'react';
import styles from './styles.module.scss';
import { useFallbackId } from '../../useFallbackId';
import { Label } from '../Label';
import { RequiredStrategy } from '../../Form';
import classNames from 'classnames';

export type InputProps = {
    label: string;
    name: string;
    containerClassName?: string;
    requiredStrategy?: RequiredStrategy;
    value: string | null;
    onChange: (value: string | null) => void;
} & Omit<InputHTMLAttributes<HTMLInputElement>, 'name' | 'placeholder' | 'value' | 'onChange'>;

export const Input = forwardRef<HTMLInputElement, InputProps>(
    (
        {
            id,
            name,
            label,
            containerClassName,
            required,
            requiredStrategy = 'required',
            value,
            onChange,
            ...props
        },
        ref
    ) => {
        const inputId = useFallbackId(id);
        const onInputChange = useCallback(
            (event: React.ChangeEvent<HTMLInputElement>) => {
                if (event.target.value === '') {
                    return onChange(null);
                }
                onChange(event.target.value);
            },
            [onChange]
        );
        return (
            <div className={classNames(styles.inputContainer, containerClassName)}>
                <input
                    ref={ref}
                    id={inputId}
                    name={name}
                    placeholder={label}
                    required={required}
                    value={value !== null ? value : ''}
                    onChange={onInputChange}
                    {...props}
                />
                <Label htmlFor={inputId} required={required} requiredStrategy={requiredStrategy}>
                    {label}
                </Label>
            </div>
        );
    }
);
